import { times } from "lodash-es"
import { ProductCardShell } from "./ProductCardShell"

import s from "./ProductCard.module.scss"

export const ProductCardSkeleton = () => {
  return (
    <ProductCardShell>
      <div className={s.skeleton}>
        <div className={s.skeleton__image} />
        <div className={s.skeleton__bottom}>
          <div className={s.skeleton__bottomType} />
          <div className={s.skeleton__bottomTitle} />
        </div>
      </div>
    </ProductCardShell>
  )
}

export const ProductCardsSkeleton = ({ count }: { count: number }) => {
  return times(count, (index) => <ProductCardSkeleton key={index} />)
}
